<template>
  <div>
    <div class="hotel-info flex flex-row items-start relative">
      <h4 class="font-bold package-title p-0 m-0">
        {{ package.hotel }}
      </h4>
      <SmallStarRating
        v-if="typeof package.accommodation_rating === 'number'"
        class="ml-2 mr-4"
        :score="package.accommodation_rating"
        :size="14"
      />
      <div
        v-if="showFavourite"
        class="hotel-info-favourite"
      >
        <FavouriteIcon :id="package.trip_package_id || package.id" />
      </div>
    </div>
    <div class="hotel-location">
      <fa
        class="mr-2"
        icon=" fa-location-dot"
      />
      <small class="font-bold">
        {{ package.zone_name !== package.destination_city ? package.zone_name + ',' : '' }} {{ package.destination_city }}, {{ package.destination_country }}
      </small>
    </div>
    <div
      v-if="package.ai_included"
      class="flex justify-start pills-container mt-4"
    >
      <div class="pill all-incusive">
        <span data-i18n="charterFilterBoardAI">
          {{ $t('charterFilterBoardAI') }}
        </span>
      </div>
    </div>
    <div class="mt-4 selling-points">
      <div
        v-for="sellingPoint in sellingPoints"
        :key="sellingPoint"
        class="inline-flex mr-4"
      >
        <fa
          class="mr-2"
          icon="check"
          size="lg"
        />
        <span class="font-bold">
          {{ sellingPoint }}
        </span>
      </div>
    </div>
    <div class="tripadvisor mt-1">
      <TripAdvisorRating
        v-if="typeof package.tripadvisor_rating === 'number'"
        parent-class="flex reference-t-2"
        :rating="package.tripadvisor_rating"
        :review-count="package.tripadvisor_count"
        :show-trip-advisor-logo="!$isSol"
        size="xs"
      />
    </div>
  </div>
</template>

<script>
const MAX_SELLING_POINTS = 2

export default defineNuxtComponent({
  name: 'HotelPackageCardHotelInfo',

  props: {
    package: {
      type: Object,
      required: true,
    },

    showFavourite: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    sellingPoints () {
      return (this.package.selling_points?.split('\r') || [])
        .filter(point => Boolean(point) && point.trim() !== 'All Inclusive')
        .slice(0, MAX_SELLING_POINTS)
    },
  },
})
</script>

<style lang="scss" scoped>
:deep(.hotel-info-favourite .favourite-icon) {
  top: -2px !important;
  right: 0 !important;
}

.hotel-info {
  justify-content: space-between;
}

.hotel-info-favourite {
  position: absolute;
  height: 40px;
  width: 40px;
  top: -50px;
  right: -10px;
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
  background-color: theme('colors.white') !important;
  z-index: 1;
}

.pills-container {
  .pill {
    color: theme('colors.black');
    padding: 0.3rem 1rem;
    border-radius: 3rem;
    font-size: 0.9rem;
    font-weight: bold;

    &.all-incusive {
      background-color: theme('colors.vivid-turquoise');
    }
  }
}

.selling-points {
  span {
    font-size: 0.9rem;
  }
}
</style>
